import { Select } from 'antd'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'

const { Option } = Select

const regionDictionary = {
  mex: 'México',
  per: 'Perú',
  col: 'Colombia'
}

/**
 * @param {{ availableRegions: string[] }} props
 */
const RegionSelector = ({
  availableRegions
}) => {
  const { region, lang, filename } = useParams()

  const regions = availableRegions.map((region, idx) => {
    return <Option value={region} key={idx}>{regionDictionary[region]}</Option>
  })

  const handleChange = region => {
    setTimeout(() => {
      window.location = `/${region}/${lang}/${filename}`
    }, 300)
  }

  return (
    <div>
      <Select size='large' value={region} bordered={false} onChange={handleChange}>
        {regions}
      </Select>
    </div>
  )
}

export default RegionSelector
